"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const transformToken = (name, token) => [
    {
        name,
        tokenType: "fontWeight",
        type: "variable",
        value: token.weight.toString(),
    },
];
exports.default = transformToken;
